module.exports = "https://cdn.hellotech.com/client-assets/advanced_audio_systems_tablet_c59611cb827af0c19449cc15d3684aa7.png";